import { Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";
import { ChunkBoundary, lazyRetryImport } from "../components/ui/ChunkBoundary";
import { HELPDESK_INCIDENTS_ENABLED } from "../config/featureFlags";

// "Atención e incidencias" (/admin/helpdesk/incidencias) — chunk lazy propio: la
// vista, su panel y su SCSS solo se descargan al entrar. ChunkBoundary + un
// reintento para que un blip de red o un deploy que cambió los hashes no escale
// al ErrorBoundary global.
const HelpdeskIncidentsView = lazy(lazyRetryImport(() => import("../pages/helpdeskIncidents")));

/**
 * Entradas de ruta de la vista para los hijos de /admin/* (que ya exigen
 * RequireAdmin). Con el flag apagado devuelve [] y la ruta NI SE REGISTRA: la URL
 * cae en el 404 del layout, como /admin/tickets. Vive fuera de routes.jsx para
 * poder probar esa condición sin cargar todas las vistas de la app.
 *
 * @param {(label: string) => React.ReactNode} renderFallback - Fallback de
 *   Suspense compartido por las vistas lazy de routes.jsx.
 * @returns {Array<{path: string, exact: boolean, element: React.ComponentType}>}
 */
export function buildHelpdeskIncidentsRoutes(renderFallback) {
  if (!HELPDESK_INCIDENTS_ENABLED) return [];

  const HelpdeskIncidentsGuarded = (props) => {
    const { t } = useTranslation();
    return (
      <ChunkBoundary label={t("Atención e incidencias")}>
        <Suspense fallback={renderFallback(t("Cargando atención e incidencias…"))}>
          <HelpdeskIncidentsView {...props} />
        </Suspense>
      </ChunkBoundary>
    );
  };

  return [{ path: "/helpdesk/incidencias", exact: true, element: HelpdeskIncidentsGuarded }];
}
